import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as Colors from 'material-ui/styles/colors';
import _ from 'lodash';
import {eventOnFirstTime} from 'shared/helpers/analyticsHelper';
import BaseElementDialog from 'crazyEditor/components/ElementsDialogs/BaseElementDialog/BaseElementDialog';
import { cLencodeURIcomponent } from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
import { WebAddressesLoader } from 'MyAccount/AssetManager/ImageManager/components/WebAddressesLoader';

const INITIAL_STATE = {
  showGalleryOrganizer: true,
  webUrlsValid: false,
  urls: [],
};

const HEIGHT_MINUS = (pixels) => {return 'calc(100vh - ' + (pixels + 128) + 'px)';};

const Consts = {
  DIALOG_WIDTH: '90%',
  DIALOG_HEIGHT: 'calc(100vh - 128px)',
  TITLE_HEIGHT: 45,
  BUTTONS_SECTION_HEIGHT: 80,
};

const styles = {
  tabContent: {
    backgroundColor: 'white',
    height: HEIGHT_MINUS(Consts.TITLE_HEIGHT + Consts.BUTTONS_SECTION_HEIGHT),
    maxHeight: HEIGHT_MINUS(Consts.TITLE_HEIGHT + Consts.BUTTONS_SECTION_HEIGHT),
    width: '100%',
    overflowY: 'auto',
    position: 'relative',
  }
};

export default class UploadImageFromUrlDialog extends Component {

  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  onWebUrlsValidChange = (webUrlsValid) => {
    this.setState({webUrlsValid});
  };

  getUrls = urls => {
    this.setState({ urls });
  };

  render() {
    const {open, newElement, uploadImagesFromUrl, closeDialog} = this.props;
    const {showGalleryOrganizer, urls, webUrlsValid} = this.state;
    return (
      <div>
        <BaseElementDialog
          open={open}
          title="Upload images from URL"
          onCancel={closeDialog}
          inputValid={webUrlsValid}
          onAddUpdate={() => {
            const urlsWithName = _.map(urls, url => ({...url, name: _.last(_.split(url.src, '/'))}));
            uploadImagesFromUrl(urlsWithName);
            closeDialog();
          }}
          primaryButtonLabel="Upload images"
          newElement={newElement}
          contentStyle={{
            width: Consts.DIALOG_WIDTH,
            maxWidth: Consts.DIALOG_WIDTH,
            height: Consts.DIALOG_HEIGHT,
            maxHeight: Consts.DIALOG_HEIGHT,
          }}
          innerDivStyle={{
            height: Consts.CONTENT_HEIGHT,
            maxHeight: Consts.CONTENT_HEIGHT,
          }}
          buttonsSectionStyle={{ backgroundColor: Colors.grey50 }}
        >
          <div style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            overflowX: 'hidden',
            overflowY: showGalleryOrganizer ? 'auto' : 'hidden',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}>
            <div
              style={styles.tabContent}
            >
              <WebAddressesLoader
                ref="webAddressesLoader"
                onValidChange={this.onWebUrlsValidChange}
                getUrls={this.getUrls}
              />
            </div>
          </div>
        </BaseElementDialog>
      </div>
    );
  }
}